import React, { useEffect, useState } from 'react'
import { DetalleParametrosDocPago, InformacionPersonaDocPagoDTO, PostParametrosDocPago } from '../TypesParametrosHorasExtras'
import { Card, CardTitle, CardBody, Row, Col, Button, Label } from "reactstrap"
import { SelectCombo } from 'components/Types/GeneralTypes'
import SelectItem2 from 'components/Varios/SelectNew'
import { showAlert } from '../Actividades/ActividadesHorasExtras'
import { ActualizarParametrosDocPago, ConsultarDetalleParametrosDocPago, CrearParametrosDocPago } from '../FunctionsParametrosHE'


type PropsCardParametrosDocPago = {
    parametrosDocPago: DetalleParametrosDocPago | null,
    listadoPersonal: InformacionPersonaDocPagoDTO[]
}

export default function CardParametrosDocPago(props: PropsCardParametrosDocPago) {

    const [elabora, setelabora] = useState<string | undefined>("")
    const [revisa, setrevisa] = useState<string | undefined>("")



    useEffect(() => {
        
        if (props.parametrosDocPago) {
            
            setelabora(
                props.parametrosDocPago.informacionElabora.identificacion
            )
            setrevisa(
                props.parametrosDocPago.informacionRevisa.identificacion
            )

        }
    }, [props])


    function MapearOpcionesPersonal(listado: InformacionPersonaDocPagoDTO[]) {
        var opcionesPersonal: SelectCombo[] = [];

        if (listado.length > 0) {
            opcionesPersonal = listado.map((v, i) => {
                return {
                    label: v.nombres,
                    value: v.identificacion
                }
            })
        }

        return opcionesPersonal
    }

    async function ConsultarDetalle() {
        const detalleParametros = await ConsultarDetalleParametrosDocPago();
        if (detalleParametros.status === 200 && detalleParametros.dataResponse) {

            const detalle: DetalleParametrosDocPago = detalleParametros.dataResponse;
            setelabora(
                detalle.informacionElabora.identificacion
            )
            setrevisa(
                detalle.informacionRevisa.identificacion
            )
        }
        else if (detalleParametros.status === 204) {
            setelabora(
                undefined
            )
            setrevisa(
                undefined
            )
        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al consultar detalle de parámetros"
            showAlert(detalleParametros.errorMessage ?? mensajeDefault, false)
        }
    }

    async function CrearParametros(listado: InformacionPersonaDocPagoDTO[], idelabora: string, idrevisa: string) {
        const informacionRevisa: InformacionPersonaDocPagoDTO | undefined = listado.find((v) => v.identificacion === idelabora);
        const informacionElabora: InformacionPersonaDocPagoDTO | undefined = listado.find((v) => v.identificacion === idrevisa);

        if (informacionRevisa && informacionElabora) {
            const postDocPago: PostParametrosDocPago = {
                informacionRevisa: informacionRevisa,
                informacionElabora: informacionElabora
            }

            const respuesta = await CrearParametrosDocPago(postDocPago)
            if (respuesta.status === 200 || respuesta.status === 204) {
                showAlert("Se han creado los parámetros para el documento de pago", true);
                await ConsultarDetalle()
            }
            else {
                showAlert("Ha ocurrido un evento inesperado", false);
            }


        }
        else {
            showAlert("No se ha identificado el servidor seleccionado", false);
            return;
        }




    }

    async function ActualizarParametros(listado: InformacionPersonaDocPagoDTO[], idelabora: string, idrevisa: string) {
        const informacionRevisa: InformacionPersonaDocPagoDTO | undefined = listado.find((v) => v.identificacion === idelabora);
        const informacionElabora: InformacionPersonaDocPagoDTO | undefined = listado.find((v) => v.identificacion === idrevisa);

        if (informacionRevisa && informacionElabora) {
            const postDocPago: PostParametrosDocPago = {
                informacionRevisa: informacionRevisa,
                informacionElabora: informacionElabora
            }

            const respuesta = await ActualizarParametrosDocPago(postDocPago)
            if (respuesta.status === 200 || respuesta.status === 204) {
                showAlert("Se han actualizado los parámetros para el documento de pago", true);
                await ConsultarDetalle();
            }
            else {
                showAlert("Ha ocurrido un evento inesperado", false);
            }


        }
        else {
            showAlert("No se ha identificado el servidor seleccionado", false);
            return;
        }




    }

    const OnChange = (newOption: SelectCombo, name: string) => {
        if (name === "elaboradopor") {
            setelabora(newOption.value);
        }
        else {
            setrevisa(newOption.value);
        }
    }





    return (
        <Card className="cardParametrosHE">
            <CardTitle className="cardHeaderParametrosPresupuesto">
                <span className='pl-3'>
                    Documento de pago
                    <span className='pl-3'>
                        <i
                            className="fas fa-info-circle"
                        />
                    </span>
                </span>
            </CardTitle>
            <CardBody className="cardBodyParametrosHE">
                <React.Fragment>
                    <Row className='row-container-bodyParamHE'>
                        <Col xl={12}>
                            <span className={"labelParametrosHE"}>Elaborado por:</span>
                        </Col>
                        <Col xl={12}>
                            {
                                props.listadoPersonal.length > 0 &&
                                <SelectItem2
                                    options={MapearOpcionesPersonal(props.listadoPersonal)}
                                    placeholder=""
                                    name="elaboradopor"
                                    id="elaboradopor"
                                    icon="fa-caret-down"
                                    value={elabora}
                                    onChange={(v, n, t, l) => OnChange({ value: v, label: l }, "elaboradopor")}
                                    center={true}

                                />
                            }
                            {
                                !elabora && <small className='small-error'> No ha indicado el usuario que elabora el doc.</small>
                            }

                        </Col>
                        <Col xl={12}>
                            <span className={"labelParametrosHE"}>Revisado por:</span>
                        </Col>
                        <Col xl={12}>
                            {
                                props.listadoPersonal.length > 0 &&
                                <SelectItem2
                                    options={MapearOpcionesPersonal(props.listadoPersonal)}
                                    placeholder=""
                                    name="revisadopor"
                                    id="revisadopor"
                                    icon="fa-caret-down"
                                    value={revisa}
                                    onChange={(v, n, t, l) => OnChange({ value: v, label: l }, "revisadopor")}
                                    center={true}

                                />
                            }
                            {
                                !revisa && <small className='small-error'> No ha indicado el usuario que revisa el doc.</small>
                            }

                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col xl={12} className="col-center">

                            {
                                !elabora && !revisa ?
                                    <Button
                                        onClick={() => CrearParametros(props.listadoPersonal, revisa ?? "", elabora ?? "")}
                                        color="secondary"
                                        disabled={!elabora || !revisa}
                                    >
                                        Guardar
                                    </Button>
                                    :
                                    <Button
                                        onClick={() => ActualizarParametros(props.listadoPersonal, revisa ?? "", elabora ?? "")}
                                        color="secondary"
                                        disabled={!elabora || !revisa}
                                    >
                                        Guardar
                                    </Button>


                            }

                        </Col>
                    </Row>

                </React.Fragment>
            </CardBody>
        </Card>
    )
}
